import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
    Button, FormControl, InputLabel, MenuItem, TableRow, Table, TableHead,
    TableBody, TableCell
} from "@material-ui/core";
import ParkService from "../dashboard/Locality/Service/parkService";
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import ticketBookingService from "./Locality/Service/ticketBookingService";
import TablePagination from '@material-ui/core/TablePagination';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import ExportExcel from "../../Excelexport";
import Loader from './Loader';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Report() {
    // Initialize with basic headers, dynamic headers will be added based on fee data
    const [tableHeaders, settableHeaders] = useState(['Date', 'Park Name']);
    const classes = useStyles();
    const [parkId, setParkId] = useState([]);
    const [result, setResult] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [pg, setpg] = React.useState(0);
    
    const [parkList, setParkList] = useState([]);
    const [rpg, setrpg] = React.useState(5);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [age, setAge] = React.useState('');
    const [getReport, setGetReport] = useState([]);
    const [open, setOpen] = React.useState(false);
    const current = new Date();
    const [grandTotal, setGrandTotal] = useState(0);
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    const [activity, setActivity] = useState({
        classId: '',
        startDate: '',
        endDate: '',
        description: '',
        activityName: '',
        status: '',
    });
    const [loading, setLoading] = useState(false);

    // Memoized table data for better performance
    const paginatedData = useMemo(() => {
        if (!getReport || getReport.length === 0) return [];
        return getReport.slice(pg * rpg, pg * rpg + rpg);
    }, [getReport, pg, rpg]);

    // Memoized table headers
    const memoizedTableHeaders = useMemo(() => {
        return tableHeaders;
    }, [tableHeaders]);

    // Memoized table row component for better performance
    const TableRowComponent = React.memo(({ report, index, isLast }) => (
        <TableRow key={report._id || index}>
            {memoizedTableHeaders.map(key => (
                <TableCell 
                    key={key}
                    className="pl-3 fw-normal"
                >
                    {isLast ? (
                        <span style={{ color: "black", fontWeight: "bold" }}>
                            {report[key] ? report[key] : 0}
                        </span>
                    ) : (
                        report[key] ? report[key] : 0
                    )}
                </TableCell>
            ))}
        </TableRow>
    ));

    useEffect(() => {
        // getParkList();
        getProfileId();
        return () => {
            setReportList([]);
            // setParkList([]);
            setGetReport([]);
        }
    }, []);
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const getProfileId = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        console.log(userDetails.role)

        const result = userDetails.role === "admin" ? null : userDetails.profileId;
        setLoading(true);
        ParkService.addAllProfileId({ profileRegistrationId: result }).then((res) => {
            if (res.length > 0) {
                setParkList(res);
                const firstValue = res[0];
                //setParkId(firstValue._id);
                onSubmit(firstValue._id);
                
            } else {
                setParkList(res);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            // setError(err.message);
        });
    }
    // Fixed sumFee function to handle dynamic fee names and sum quantities
    const sumFee = useCallback((data,parkName) => {
        if (!data || data.length === 0) return {};
        
        const mergedFeeDetails = {};
        
        console.log('sumFee processing data:', data.length, 'documents');
        
        // Process all documents and accumulate properly
        for (let i = 0; i < data.length; i++) {
            debugger
            const document = data[i];
            if (!parkName) continue;
            
            // Set park name from first document
            if (i === 0) {
                mergedFeeDetails['Park Name'] = parkName;
            }
            
            // Process fee array for this document
            if (document.fee && Array.isArray(document.fee)) {
                document.fee.forEach((feeDetail, feeIndex) => {
                    const name = feeDetail.name; // e.g., "ticket", "adult", "child", etc.
                    const price = feeDetail.price || 0;
                    const qty = feeDetail.quantity || 0;
                    const totalprice = feeDetail.totalprice || (qty * price);
                    
                    // Create dynamic keys based on fee name
                    const countKey = name; // Just use the name for count (e.g., "ticket")
                    const amountKey = name + ' Amount'; // Add "Amount" suffix for amounts
                    
                    // Initialize if not exists, then add
                    if (!mergedFeeDetails[countKey]) {
                        mergedFeeDetails[countKey] = 0;
                    }
                    if (!mergedFeeDetails[amountKey]) {
                        mergedFeeDetails[amountKey] = 0;
                    }
                    
                    // Accumulate quantities and amounts
                    mergedFeeDetails[countKey] += qty;
                    mergedFeeDetails[amountKey] += totalprice;
                    
                    console.log(`Document ${i}, Fee ${feeIndex}: ${name} - Qty: ${qty}, Price: ${price}, Total: ${totalprice}`);
                });
            }
        }
        
        console.log('sumFee result:', mergedFeeDetails);
        return mergedFeeDetails;
    }, []);
    // Updated totalSum function to use totalprice from fee array
    const totalSum = useCallback((data) => {
        if (!data || data.length === 0) return 0;
        
        let total = 0;
        
        // Process all documents efficiently
        for (let i = 0; i < data.length; i++) {
            const document = data[i];
            if (document.fee && Array.isArray(document.fee)) {
                for (let j = 0; j < document.fee.length; j++) {
                    const feeDetail = document.fee[j];
                    const totalprice = feeDetail.totalprice || 0;
                    total += totalprice;
                }
            }
        }
        
        return total;
    }, []);
    const totalAmount = ((sum, day,) => {
        const dailyTotal = day.documents.reduce((dailySum, doc) => dailySum + doc.totalAmount, 0);
        return sum + dailyTotal;
    }, 0);
    // Optimized groupByParkId function
    const groupByParkId = useCallback((data) => {
        if (!data || data.length === 0) return [];
        
        // Use a more efficient sorting approach
        return [...data].sort((a, b) => {
            if (!a.parkId || !b.parkId) return 0;
            return a.parkId.localeCompare(b.parkId);
        });
    }, []);

    // Debounce function for search operations
    const debounce = useCallback((func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }, []);
    // Optimized onSubmit function with better performance
    const onSubmit = useCallback((data) => {
        const report = JSON.parse(localStorage.getItem("userDetail"));
        let newstartDate1 = startDate1 ? startDate1 : null;
        let newendDate1 = endDate1 ? endDate1 : null;

        const keys = { 
            "parkId": data ? data : parkId, 
            "startDate": newstartDate1, 
            "endDate": newendDate1 ? `${newendDate1}T23:59:00.000Z` : '' 
        };
        
        setLoading(true);
        
        ticketBookingService.getTicketBookingList(keys).then((res) => {
            if (res && res.length > 0) {
                // Debug: Log the raw API response structure
                console.log('Raw API response:', res);
                console.log('First item structure:', res[0]);
                if (res[0] && res[0].documents) {
                    console.log('First document structure:', res[0].documents[0]);
                    if (res[0].documents[0] && res[0].documents[0].fee) {
                        console.log('First fee array:', res[0].documents[0].fee);
                    }
                }
                
                // Process data efficiently
                const resultDetails = groupByParkId(res);
                
                // Use useMemo-like approach for expensive calculations
                const processedResults = resultDetails.map(result => {
                    const feeData = sumFee(result.documents,result.parkName);
                    const totalAmount = totalSum(result.documents);
                    
                    // Debug log to check the data
                    console.log('Processing result:', {
                        date: result.createdAt,
                        documentsCount: result.documents.length,
                        feeData,
                        totalAmount
                    });
                    
                    return {
                        Date: result.createdAt,
                        ...feeData,
                        'Total Amount': totalAmount,
                    };
                });
                
                // Calculate totals efficiently
                const grandTotal = processedResults.reduce((sum, item) => sum + (item['Total Amount'] || 0), 0);
                setGrandTotal(grandTotal);
                
                // Create total row efficiently - handle amounts and counts separately
                const totalRow = { "Date": "Total", "Park Name": "N/A" };
                if (processedResults.length > 0) {
                    const firstRow = processedResults[0];
                    Object.keys(firstRow).forEach(key => {
                        if (typeof firstRow[key] === "number") {
                            // Sum all numeric values (both amounts and counts)
                            totalRow[key] = processedResults.reduce((sum, row) => sum + (row[key] || 0), 0);
                        }
                    });
                }
                
                const finalResults = [...processedResults, totalRow];
                
                // Set headers dynamically based on the data structure
                if (finalResults.length > 0) {
                    const headerDetails = Object.keys(finalResults[0]);
                    // Ensure 'Total Amount' is always at the end
                    const sortedHeaders = headerDetails.sort((a, b) => {
                        if (a === 'Date') return -1;
                        if (b === 'Date') return 1;
                        if (a === 'Park Name') return -1;
                        if (b === 'Park Name') return 1;
                        if (a === 'Total Amount') return 1;
                        if (b === 'Total Amount') return -1;
                        return a.localeCompare(b);
                    });
                    settableHeaders(sortedHeaders);
                }
                
                excelExport(finalResults);
                setGetReport(finalResults);
            } else {
                setGetReport([]);
                setGrandTotal(0);
            }
            setLoading(false);
        }).catch((err) => {
            console.error('Error fetching ticket booking list:', err);
            setLoading(false);
            setGetReport([]);
            setGrandTotal(0);
        });
    }, [startDate1, endDate1, parkId, groupByParkId, sumFee, totalSum]);

    const  excelExport  =(res)  => {
      
            

       
          setResult(res);
     };

    const getParkList = () => {
        ParkService.getAllPark().then((res) => {

            setParkList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    return (
        <>
            <PageTitle title="Reports" />
            <Card sx={{ maxWidth: 345 }}>
                <Box   >
                    <div >
                        <form >
                            <Grid container spacing={2} columns={12} style={{ margin: 10 }}  >
                                
                                <Grid item xs={6} sm={6} md={2} >
                                    <FormControl className={classes.formControl} fullWidth="true"
                                    >
                                        <InputLabel id="demo-simple-select-label">Select Park</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="parkId"
                                            label="Select Park"
                                            multiple
                                            value={parkId}
                                            
                                            onChange={(e) => setParkId(e.target.value)}
                                            renderValue={(selected) => {
                                                // Find student names for the selected IDs
                                                const selectedNames = parkList
                                                  .filter(({ _id }) => selected.includes(_id))
                                                  .map(({ parkName }) => parkName);
                                                return selectedNames.join(", ");
                                              }}
                                        >


                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>

                                            {parkList.map(({index, _id, parkName }) => (
                                                <MenuItem key={index} value={_id}>{parkName}

                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} sm={6} md={2}>
                                    <form className={classes.container} noValidate>
                                        <TextField InputProps={{ style: { width: 150 } }}
                                            id="dob"
                                            name="dob"
                                            label="Start Date"
                                            type="date"
                                            min="2016-11-10"
                                            max="2022-11-10"
                                            value={startDate1}
                                            onChange={e => { setStartDate1(e.target.value) }}
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </form>
                                </Grid>
                                <Grid item xs={6} sm={6} md={2} >
                                    <TextField InputProps={{ style: { width: 120 } }}
                                        id="dob"
                                        name="dob"
                                        label="End Date"
                                        type="date"
                                        min="2016-11-10"
                                        max="2022-11-10"
                                        value={endDate1}
                                        onChange={e => { setEndDate1(e.target.value) }}
                                        // defaultValue="2017-05-24"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={2} >
                                    <Button 
                                        style={{ backgroundColor: 'rgb(255 107 129)', color: 'white' }}
                                        type="button" 
                                        onClick={() => onSubmit()} 
                                        variant="contained"
                                        disabled={loading}
                                    >
                                        {loading ? 'Searching...' : 'Search'}
                                    </Button>
                                </Grid>
                                
                                <Grid item xs={6} sm={6} md={2}  >
                                <ExportExcel   excelData={result} fileName={'Reports'} />
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </Box>
            </Card>
            {loading && <Loader />}
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                    <h6>Grand Total: ₹ {grandTotal}</h6>
                    <br></br>
                        {getReport.length > 0 ? (
                            <Table className="mb-0">
                                <TableHead>
                                    <TableRow>
                                        {memoizedTableHeaders.map(key => (
                                            <StyledTableCell key={key}>{key.toUpperCase()}</StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedData.map((report, index) => {
                                        const isLast = index === paginatedData.length - 1;
                                        return (
                                            <TableRowComponent
                                                key={report._id || index}
                                                report={report}
                                                index={index}
                                                isLast={isLast}
                                            />
                                        );
                                    })}
                                </TableBody>
                      
                            </Table>
                        ) : (
                            <p style={{ textAlign: "center" }}> No data to display.</p>
                        )}

                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            count={getReport.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
        </>
    );
}


